import { Box } from "@mui/material";
import { styled } from '@mui/system';

export const HBox = styled(Box)`
  flex-direction:row;
  display:flex;
`;

export const VBox = styled(Box)`
    flex-direction:column;
    display:flex;
`;
 
